module.exports = __webpack_public_path__ + "static/media/AJ_JPP6.8bc20478.jpg";